import React from 'react';
import { Field, FieldArray } from 'redux-form';
import { Row, FormGroup } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { useFlags } from 'launchdarkly-react-client-sdk';
import AdultRows from './AdultRows';
import AdultRowsV2 from './AdultRowsV2';
import messages from './messages';

import { renderSelectField } from '../../../../utils/redux-form-helper';
import generateNumberOfOptions from '../../../../utils/index.js';

type ComponentProps = {
  intl: any,
  suffixes: Array<Object>,
  relationships: Array<Object>,
  change: Function,
};

const selectOptions = generateNumberOfOptions(11);

const Adults = ({ intl, suffixes, relationships, change }: ComponentProps) => {
  const { additionalPhoneAndEmailFieldsForLeadProfile } = useFlags();

  return (
    <FormGroup className="applicant-subgrp">
      <Row>
        <div className="additional-occupants-head">
          <h3>
            <FormattedMessage {...messages.other} />
          </h3>
          <div className="head-subtitle">
            <FormattedMessage {...messages.adultsHowMany} />
          </div>
          <div className="head-selector">
            <Field
              name="adultsCount"
              component={renderSelectField}
              options={selectOptions}
              selectClassNames="input-lg"
            />
          </div>
        </div>
      </Row>
      <FieldArray
        name="adults"
        intl={intl}
        component={
          additionalPhoneAndEmailFieldsForLeadProfile ? AdultRowsV2 : AdultRows
        }
        suffixes={suffixes}
        relationships={relationships}
        change={change}
      />
    </FormGroup>
  );
};

export default Adults;
